export type MobileWebOs = 'ios' | 'android';

/**
 * Pure UA classifier. Lives in a separate file from the Platform-aware
 * {@link detectMobileWebOs} so unit tests do not need to import react-native.
 */
export function detectMobileWebOsFromUserAgent(userAgent: string | null | undefined): MobileWebOs | null {
  if (!userAgent) return null;
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'ios';
  if (/Android/i.test(userAgent)) return 'android';
  return null;
}
